// src/components/ui/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiInstagram, FiFacebook, FiTwitter, FiYoutube } from 'react-icons/fi';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'home', to: '/' },
    { name: 'menu', to: '/menu' },
    { name: 'about', to: '/about' }
  ];

  const restaurantLinks = [
    { name: 'pickup', href: 'https://eat.allo.restaurant/restaurant/golden-arm-indisches-restaurant' },
    { name: 'reservation', href: 'https://reservations.allo.restaurant/de/golden-arm-indisches-restaurant' },
    { name: 'voucher', href: 'https://eat.allo.restaurant/restaurant/golden-arm-indisches-restaurant/gift-cards' }
  ];

  return (
    <footer className="bg-primary text-accent py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand & Social */}
          <div className="text-center sm:text-left">
            <Link to="/">
              <img src="/assets/images/main-logo.png" alt="Golden Arm Logo" className="w-32 sm:w-36 mb-4 mx-auto sm:mx-0" />
            </Link>
            <p className="mb-4 text-sm sm:text-base">{t('description')}</p>
            <div className="flex justify-center sm:justify-start space-x-4">
              <a href="#" className="hover:text-secondary transition-colors" aria-label="Instagram"><FiInstagram size={24} /></a>
              <a href="#" className="hover:text-secondary transition-colors" aria-label="Facebook"><FiFacebook size={24} /></a>
              <a href="#" className="hover:text-secondary transition-colors" aria-label="Twitter"><FiTwitter size={24} /></a>
              <a href="#" className="hover:text-secondary transition-colors" aria-label="YouTube"><FiYoutube size={24} /></a>
            </div>
          </div>

          {/* Quicklinks */}
          <div className="text-center sm:text-left">
            <h4 className="font-display text-lg sm:text-xl mb-3 sm:mb-4">{t('quicklinks')}</h4>
            <ul className="space-y-2">
              {quickLinks.map(link => (
                <li key={link.name}>
                  <Link to={link.to} className="hover:text-secondary transition-colors text-sm sm:text-base">
                    {t(link.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Restaurant Links */}
          <div className="text-center sm:text-left">
            <h4 className="font-display text-lg sm:text-xl mb-3 sm:mb-4">{t('restaurant')}</h4>
            <ul className="space-y-2">
              {restaurantLinks.map(link => (
                <li key={link.name}>
                  <a href={link.href} className="hover:text-secondary transition-colors text-sm sm:text-base" target="_blank" rel="noopener noreferrer">
                    {t(link.name)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center sm:text-left">
            <h4 className="font-display text-lg sm:text-xl mb-3 sm:mb-4">{t('contact')}</h4>
            <address className="not-italic space-y-1 text-sm sm:text-base">
              <p>{t('addressLine1')}</p>
              <p>{t('addressLine2')}</p>
              <p>{t('phone')}: 02921 559 55 28</p>
              <p>{t('email')}</p>
            </address>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-accent border-opacity-20 mt-8 pt-6 text-center text-xs sm:text-sm">
          <p>{t('copyright', { year: currentYear })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
